'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (theme) {
    var styleList = _aphroditeJss.StyleSheet.create({
        noScroll: {
            overflowY: 'hidden',
            overflowX: 'hidden'
        },
        fx: {
            filter: theme.overlayFilter
        }
    });

    return {
        fx: (0, _aphroditeJss.css)(styleList.fx),
        noScroll: (0, _aphroditeJss.css)(styleList.noScroll)
    };
};

var _aphroditeJss = require('aphrodite-jss');